import React, { useEffect, useState } from 'react';
import './minimalHome.css';

const SWIRL_IMAGES = [
  `${process.env.PUBLIC_URL}/swirl1.png`,
  `${process.env.PUBLIC_URL}/swirl2.png`,
];

const MinimalHome = () => {
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    const font = new FontFace('ds', `url(${process.env.PUBLIC_URL}/assets/fonts/ds.ttf)`);
    font
      .load()
      .then((loadedFont) => {
        document.fonts.add(loadedFont);
      })
      .catch(() => {
        // Keep fallback font if the DS font fails to load.
      });
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setImageIndex((current) => (current + 1) % SWIRL_IMAGES.length);
    }, 500);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <main className="minimal-home" aria-label="Ocarin landing page" style={{marginTop:"5%"}}>
      <img
        className="minimal-home__swirl"
        src={SWIRL_IMAGES[imageIndex]}
        alt="Animated swirl"
      />
      <h1 className="minimal-home__title">Ocarin</h1>

      {/* <br/>
      <br/>
      ________________________________________________________________ */}
    </main>
  );
};

export default MinimalHome;
